// extracted by mini-css-extract-plugin
module.exports = {"main":"ReferencePoint_main__2W7nI","grid":"ReferencePoint_grid__2SJUL","point":"ReferencePoint_point__3wzKN"};